"use client";

import { getCategoryCanonicalUrlV2 } from "api/category/getCategoryCanonicalUrlV2";
import { IPageContent } from "api/interfaces/static-content.type";
import { FILTER_TYPE } from "constant/product-filter.action";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { TRACKING_EVENT_NAME } from "util/analytics/tracking.service";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import SsrProductContainer from "../../component/category/SsrProductContainer";
import { sendCategoryViewEvent } from "../../util/analytics/sendCategoryViewEvent";
import { encode } from "../../util/helper/encode";
import { filterObjectKeys } from "../../util/lodash/filterObjectKeys";
import ManufacturerMetaHead from "./ManufacturerMetaHead";

interface IProps{
  staticContent: IPageContent;
}

function ManufacturerTierContainer(props: IProps) {
  const didMountRef = useRef(false);

  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  const {
    productsAggregation, pageType, tiersWithUrls, manufacturerUrl, breadCrumbsV2,
    staticContent,
  } = props;
  const { urlInformation } = useSelector((state: RootState) => state.utils);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { products, manufacturers, ...filterOptions } = productsAggregation;
  const {
    tier0, tier1, tier2, tier3, make, model, year, manufacturer,
  } = urlInformation || {};

  const bannerData = {
    // bannerImageUrl, categoryDisplayableTitle, categoryDescription: categoryDescriptionText,
  };

  const router = useRouter();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { pathname, ...queryFilters } = router.query;
  const {
    fitments: ft, availability: av, priceRanges: pr, manufacturers: m, pageNumber: pg, sortBy: sb,
  } = router.query || {};

  useEffect(() => {
    // when change in selectedVehicle or query, send analytics.
    sendCategoryViewEvent({
      tier0, t1: tier1, t2: tier2, t3: tier3, ft, av, pr, m, make, model, year, pg, sb, manufacturer,
    }, TRACKING_EVENT_NAME.MANUFACTURER_CATEGORY_PAGE_VIEW);
  }, [selectedVehicle, router.query]);

  useEffect(() => {
    if (didMountRef.current) {
      getCategoryCanonicalUrlV2(urlInformation, selectedVehicle, null)
        .then((res: any) => {
          const { url, success, queryParams } = res.data;
          if (success) {
            const {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
              make: ma, model: mo, year: yr, ...buildQueryParams // We don't want to pass make, model, year
            } = queryFilters;
            buildQueryParams.manufacturers = urlInformation.manufacturer;
            const { href, asPath } = getHrefAndPath({
              query: { ...queryParams, ...buildQueryParams }, asPath: url,
            });

            if (window.location.pathname !== url) {
              router.replace(href, asPath);
            }
          }
        });
    } else {
      didMountRef.current = true;
    }
  }, [selectedVehicle]);

  const breadcrumbData = filterObjectKeys(urlInformation, ["tier0", "tier1", "tier2", "tier3"]);

  return (
    <>

      <ManufacturerMetaHead {...{
        query: router.query,
        tier3,
        tier2,
        tier1,
        tier0,
        make,
        model,
        year,
        manufacturerUrl,
        manufacturer: urlInformation.manufacturer,
        totalHits: products.totalHits || 0,
        products: products.products || [],
        tiersWithUrls,
        staticContent: { pageDetails: {} },
      }}
      />

      <SsrProductContainer
        url="/[pathname]"
        hideQsParams={["t0", "t1", "make", "model", "year", "pathname"]}
        filterValues={{
          [FILTER_TYPE.TIER0]: encode(tier0, "(_|-)", " "),
          [FILTER_TYPE.TIER1]: tier1,
          [FILTER_TYPE.TIER2]: tier2,
          [FILTER_TYPE.TIER3]: tier3,
          [FILTER_TYPE.MANUFACTURER]: m ? [].concat(m) : [],
          [FILTER_TYPE.PRICE]: pr ? [].concat(pr) : [],
          [FILTER_TYPE.AVAILABILITY]: av ? [].concat(av) : [],
          [FILTER_TYPE.FITMENT]: ft ? [].concat(ft) : [],
        }}
        immutableFilters={[FILTER_TYPE.TIER0]}
        bannerData={bannerData}
        breadcrumbData={breadcrumbData}
        tiersWithUrls={tiersWithUrls}
        staticContent={staticContent}
        filterParams={{
          vehicle: { enabled: false },
        }}
        pageType={pageType}
        {...{
          breadCrumbsV2,
          filterOptions,
          productList: {
            products: products.products || [],
            totalHits: products.totalHits || 0,
          },
          categoryAggregation: productsAggregation.categoryAggregation,
        }}
      />
    </>
  );
}

export default ManufacturerTierContainer;
